'use client';

import { ErrorPage } from '@/shared/ui';
import { useTranslations } from 'next-intl';

export default function NotFound() {
  const t = useTranslations('error');
  const handleClickHome = () => {
    window.location.href = '/';
  };

  return (
    <ErrorPage
      title={t('notFound.title')}
      description={[t('notFound.description1'), t('notFound.description2')]}
      onClickHome={handleClickHome}
    />
  );
}
